// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bfTME","largestCol":"styles_largestCol__htIId","smallestCol":"styles_smallestCol__2v1UT"};